<template>
  <header class="header" :style="currentStyle.background">
    <div class="contenido-header contenedor">
      <div class="barra">
        <div class="logo" @click="changeHeader('inicio')">
          <router-link to="inicio">
            <img src="@/assets/img/logo.svg" alt="Logo Cafeteria">
          </router-link>
        </div>
        <nav class="nav-principal">
          <a @click="changeHeader('inicio')">
            <router-link to="inicio">Inicio</router-link>
          </a>
          <a @click="changeHeader('nosotros')">
            <router-link to="nosotros">Nosotros</router-link>
          </a>
          <a @click="changeHeader('proceso')">
            <router-link to="proceso">Proceso</router-link>
          </a>
          <a @click="changeHeader('menu')">
            <router-link to="menu">Menú</router-link>
          </a>
          <a @click="changeHeader('galeria')">
            <router-link to="galeria">Galería</router-link>
          </a>
          <a @click="changeHeader('contacto')">
            <router-link to="contacto">Contacto</router-link>
          </a>
        </nav>
      </div>
      <div class="texto-header">
        <h1>{{currentStyle.text}}</h1>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      selectedHeader: 'inicio',
      currentStyle: {
        background: {backgroundImage: 'url(' + require('@/assets/img/header_inicio.jpg') + ')'},
        text: 'Disfruta el verdadero sabor del café'
      }
    }
  },
  methods: {
    changeHeader(newHeader) {
      this.selectedHeader = newHeader;
    }
  },
  watch: {
    selectedHeader(newValue, oldValue) {
      if(newValue == oldValue) {
        return;
      }
      switch(newValue) {
        case 'inicio':
          this.currentStyle.background.backgroundImage = 'url(' + require('@/assets/img/header_inicio.jpg') + ')';
          this.currentStyle.text = 'Disfruta el verdadero sabor del café';
          break;
        case 'nosotros':
          this.currentStyle.background.backgroundImage = 'url(' + require('@/assets/img/header_nosotros.jpg') + ')';
          this.currentStyle.text = 'La experiencia que queremos compartir';
          break;
        case 'proceso':
          this.currentStyle.background.backgroundImage = 'url(' + require('@/assets/img/header_proceso.jpg') + ')';
          this.currentStyle.text = 'Los expertos del café';
          break;
        case 'menu':
          this.currentStyle.background.backgroundImage = 'url(' + require('@/assets/img/header_menu.jpg') + ')';
          this.currentStyle.text = 'Cafés, emparedados, felicidad';
          break;
        case 'galeria':
          this.currentStyle.background.backgroundImage = 'url(' + require('@/assets/img/header_galeria.jpg') + ')';
          this.currentStyle.text = 'Imágenes que puedes oler';
          break;
        case 'contacto':
          this.currentStyle.background.backgroundImage = 'url(' + require('@/assets/img/header_contacto.jpg') + ')';
          this.currentStyle.text = 'Mejores granos, mejor café';
          break;
        default: 
          this.currentStyle.background.backgroundImage = 'url(' + require('@/assets/img/header_inicio.jpg') + ')';
          this.currentStyle.text = 'Disfruta el verdadero sabor del café';
          break;
      }
      return;
    }
  }
}
</script>

<style scoped>
.header {
  background-repeat: no-repeat;
  background-size: cover;
  padding: 5rem 0;
  position: relative;
  z-index: 0;
}
@media (min-width: 480px) {
  .header {
    padding: 4rem;
  }
}
@media (min-width: 768px) {
  .header {
    padding: 3rem;
    min-height: 60rem;
  }
}
@media (min-width: 1024px) {
  .header {
    padding: 2rem;
  }
}
.header::before {
  content: "";
  background-color: #000;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.5;
}
.header .contenido-header {
  position: relative;
}
.header .contenido-header h1 {
  text-align: center;
  color: #fff;
  text-transform: uppercase;
  margin-top: 5rem;
}
@media (min-width: 768px) {
  .header .contenido-header h1 {
    margin-top: 10rem;
  }
}

.nav-principal {
  display: flex;
  flex-direction: column;
  margin-top: 5rem;
}
@media (min-width: 768px) {
  .nav-principal {
    flex-direction: row;
    gap: 1rem;
    margin-top: 0;
  }
}
.nav-principal a {
  text-align: center;
  color: #fff;
  font-size: 2rem;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 1.25rem;
}
@media (min-width: 768px) {
  .nav-principal a {
    margin-bottom: 0;
  }
}
.nav-principal a:hover {
  color: #B5B3AE;
}
.nav-principal a.router-link-active {
  color: #c39c63;
}

.barra {
  display: flex;
  flex-direction: column;
}
@media (min-width: 768px) {
  .barra {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}
.barra .logo {
  width: 50%;
  margin: 0 auto;
}
@media (min-width: 768px) {
  .barra .logo {
    width: 20rem;
    margin: 0;
  }
}
</style>